
import { Link, VStack, Text, Icon } from "@chakra-ui/react"
import {
    SectionForm, LabelInfo, TextDateFormat, TextTelFormat,
    BadgeFormStatus, BadgeFormApproveStatus
} from "../shared"
import { BsFileEarmarkText } from "react-icons/bs";
import { FormDownloadButton} from "../formstep2/FormInfo"

// form_request_scan_document
const LabelFileViewer = ({ doc, otherdoc }) => {
    const nameText = doc.scan_document?.id === 6 ? `${doc.scan_document?.name} - ${otherdoc}` : doc.scan_document?.name

    return (
        <LabelInfo title={nameText} size="sm">
            {doc.file_path ?
                <Link href={doc.file_path_url} isExternal>
                    <Text color="blue"><Icon as={BsFileEarmarkText} mr={1} />ดูไฟล์</Text>
                </Link> :
                <Text color="red">ยังไม่ได้แนบไฟล์</Text>
            }
        </LabelInfo>
    )
}

const FormFullInfo = ({ data, collapse = false, showStatus = false, showApproveStatus = false }) => {

    return (
        <VStack w="full">
            <SectionForm header="แบบฟอร์ม" collapse={collapse}>
                <LabelInfo title="เขียนที่">{data.form_local}</LabelInfo>
                <LabelInfo title="วันที่"><TextDateFormat value={data.form_date} full={true} datetime={false} /></LabelInfo>
                <LabelInfo title="เรียน">คณะทำงานบริหารอาคารที่พักข้าราชการศาลยุติธรรมในเขตกรุงเทพมหานคร</LabelInfo>
            </SectionForm>
            <SectionForm header="ข้อมูลผู้ขอ">
                <LabelInfo title="ข้าพเจ้า">{`${data.requester_first_name} ${data.requester_last_name}`}</LabelInfo>
                <LabelInfo title="ตำแหน่ง">{data.requester_position_name}</LabelInfo>
                <LabelInfo title="ระดับ">{data.level_name}</LabelInfo>
                <LabelInfo title="สังกัด">{data.office_name}</LabelInfo>
                <LabelInfo title="โทรศัพท์"><TextTelFormat value={data.tel} /></LabelInfo>
            </SectionForm>
            <SectionForm header="สถานะภาพ" collapse={collapse}>
                <LabelInfo title="สถานะภาพ">{data.marital_status_name}</LabelInfo>
                {
                    data.marital_status_id > 1 && (
                        <>
                            <LabelInfo title="คู่สมรสชื่อ">{data.spouse_full_name}</LabelInfo>
                            <LabelInfo title="ตำแหน่ง">{data.spouse_position_name}</LabelInfo>
                            <LabelInfo title="สถานที่ปฏิบัติงาน">{data.spouse_office_name}</LabelInfo>
                            <LabelInfo title="มีบุตร จำนวน">{data.children || '-'} คน</LabelInfo>
                        </>
                    )
                }
            </SectionForm>
            <SectionForm header="ที่อยู่ปัจจุบัน" collapse={collapse}>
                <LabelInfo title="ปัจจุบันมีชื่ออยู่ในทะเบียนบ้านเลขที่">{data.address}</LabelInfo>
                <LabelInfo title="ซอย/ถนน">{data.soi}</LabelInfo>
                <LabelInfo title="แขวง/ตำบล">{data.subdistrict}</LabelInfo>
                <LabelInfo title="เขต/อำเภอ">{data.district}</LabelInfo>
                <LabelInfo title="จังหวัด">{data.province}</LabelInfo>
                <LabelInfo title="ซึ่งบ้านดังกล่าวเป็นของ">{data.house_owner_name}</LabelInfo>
                <LabelInfo title="โดยเป็น">{data.house_status_name}{data.house_status_id === 4 && ` (${data.house_other_status_name})`}</LabelInfo>
            </SectionForm>
            <SectionForm header="มีความประสงค์">
                <LabelInfo title="ขอเข้าพักอาศัย">{data.residence_name}</LabelInfo>
            </SectionForm>
            <SectionForm header="สถานะแบบฟอร์ม" collapse={!showStatus} bgColor="pink.50">
                <LabelInfo title="สถานะ"><BadgeFormStatus data={data} /></LabelInfo>
                <LabelInfo title="วันที่ยื่นแบบคำร้อง"><TextDateFormat value={data.submit_date} full={true} /></LabelInfo>
            </SectionForm>
            <SectionForm header="สถานะการตรวจสอบฟอร์มคำร้อง" collapse={!showApproveStatus} bgColor="facebook.50">
                <LabelInfo title="ผลการตรวจสอบ"><BadgeFormApproveStatus data={data} /></LabelInfo>
                <LabelInfo title="วันที่ตรวจสอบ"><TextDateFormat value={data.approve_date} full={true} /></LabelInfo>
                <LabelInfo title="หมายเหตุ">{data.approve_note}</LabelInfo>
                <LabelInfo title="ผู้ตรวจสอบ(เจ้าหน้าที่)">{data.approver_name}</LabelInfo>
            </SectionForm>
            <SectionForm header="แบบฟอร์มคำร้อง" >
                {/* {data.file_path ?
                    <Link href={data.file_path_url} isExternal>
                        <Text color="blue"><Icon as={BsFileEarmarkText} mr={1} />ดูไฟล์แบบฟอร์มคำขอ</Text>
                    </Link> :
                    <Text color="red">ยังไม่ได้แนบไฟล์</Text>
                } */}
                <FormDownloadButton fid={data.id}/>
            </SectionForm>
            <SectionForm header="เอกสารที่เกี่ยวข้อง" divider={false}>
                {
                    data.form_request_scan_document && data.form_request_scan_document?.map(doc =>
                        <LabelFileViewer doc={doc} otherdoc={data.other_document_name} />)
                }
            </SectionForm>

        </VStack>
    )
}

export default FormFullInfo